import { createTheme, Grid, Group, ScrollArea, Stack } from '@mantine/core';

export const mantineTheme = createTheme({
    cursorType: 'pointer',
    components: {
        Stack: Stack.extend({
            defaultProps: {
                gap: 'xs',
            },
        }),
        Group: Group.extend({
            defaultProps: {
                gap: 'xs',
                wrap: 'nowrap',
            },
        }),
        Grid: Grid.extend({
            defaultProps: {
                gutter: 'xs',
            },
        }),
        ScrollArea: ScrollArea.extend({
            defaultProps: {
                type: 'auto',
            },
        }),
    },
    colors: {
        primaryTeal: ['#e5fafe', '#daeef1', '#bdd7dd', '#9bc0c7', '#7facb5', '#6da0aa', '#619aa6', '#4e8791', '#417883', '#2c6874'],
    },
    // primaryShade: 9,
    fontFamily: 'Roboto',
    primaryColor: 'primaryTeal',
});
